import { RuleSetStrategy } from '../strategies/RuleSetStrategy';
import { RuleContextToApply } from '../types/RuleContext';

export class RulesApplier<T> {
  private readonly strategy: RuleSetStrategy<T>;

  constructor(strategy: RuleSetStrategy<T>) {
    this.strategy = strategy;
  }

  apply(context: Partial<RuleContextToApply<T>>): T {
    const rules = this.strategy.getRules(context);

    return rules.reduce((acc, rule) => {
      const newContext = { ...context, acc } as RuleContextToApply<T>;
      return rule.apply(newContext);
    }, context.acc || ([] as unknown as T));
  }
}
